// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"3a1c4a6e","163":"f2646ac2","640":"2fdeeb70","802":"72cefc8e"}[chunkId] + ".chunk.js";
};